import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {ConfirmationService, SelectItem} from 'primeng/api';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {NavService} from '../../../_services/_nav.service';
import {forkJoin} from 'rxjs';
import {Modalidad} from '../../../_models/modalidad';
import {ListaService} from '../../../_services/lista.service';
import {ListaItem} from '../../../_models/lista-item';
import {ModalidadAutorizacionService} from '../../../_services/modalidad-autorizacion.service';
import {ModalidadService} from '../../../_services/modalidad.service';
import {ModalidadCalificacion} from '../../../_models/modalidad-calificacion';
import {ModalidadCalificacionService} from '../../../_services/modalidad-calificacion.service';
import {Funcionalidad} from '../../../_models/funcionalidad';
import {AutenticacionService} from '../../../_services/autenticacion.service';

@Component({
  selector: 'app-modalidades-calificaciones',
  templateUrl: 'modalidades-calificaciones.component.html'
})

export class ModalidadesCalificacionesComponent implements OnInit {

  @Input() modalidad: Modalidad;
  @Output() dismiss: EventEmitter<string> = new EventEmitter();
  modalidadCalificacion: ModalidadCalificacion;

  lisCategorias: SelectItem[] = [];
  // Lista para todas las categorias existentes en la lista ListasCategoriasModalidadesCalificaciones
  lisTodasCategorias: ListaItem[] = [];
  lisTodasModalidadesCalificaciones: ModalidadCalificacion [] = [];
  lisModalidadesCalificaciones: ModalidadCalificacion [] = [];

  // Lista de modalidades tasas


  autorizaciones: any [] = [];
  carInformacionInicial = true;
  formulario: FormGroup;
  formularioCalificacion: FormGroup;
  submitted = false;
  submittedCalificacion = false;
  guardando = false;
  guardandoCalificacion = false;
  columnas: any[];
  menu: Funcionalidad = new Funcionalidad();

  constructor(private autServicio: AutenticacionService,
              private modAutServicio: ModalidadAutorizacionService,
              private modCaliServicio: ModalidadCalificacionService,
              private modServicio: ModalidadService,
              private conServicio: ConfirmationService,
              private lisServicio: ListaService,
              private nav: NavService,
              private confirmationService: ConfirmationService,
              private fb: FormBuilder) {

  }

  ngOnInit(): void {

    const mn = this.autServicio.obtenerFuncionalidades().find( x => x.ruta === 'apl/modalidades' );
    if ( mn ) {
      this.menu = mn;
    }

    // Definiendo columnas datatable
    this.columnas = [
      {field: 'categoria', header: this.nav.buscarMensaje('MODALIDADES.LBL_CATEGORIA'), sort: false},
      {field: 'diaMin', header: this.nav.buscarMensaje('MODALIDADES.LBL_DIAMINMORA'), sort: false},
      {field: 'diaMax', header: this.nav.buscarMensaje('MODALIDADES.LBL_DIAMAXMORA'), sort: false},
      {field: 'diaMax', header: this.nav.buscarMensaje('LBL_ACCIONES'), sort: false},
    ];
    //Inicializando formulario
    this.inicializarFormularios();
    // Inicializando las listas
    this.inicializarListas();
  }

  // Se seleccionan las ModalidadesCalificaciones que se encuentran habilitadas
  llenarModalidadesCalificaciones() {
    this.lisModalidadesCalificaciones = [];
    this.lisModalidadesCalificaciones = this.lisTodasModalidadesCalificaciones.filter(
      modCal => modCal.indicadorHabilitado === true);

    // Se filtran las categorias
    this.filtrarCategorias();
  }

  inicializarListas() {
    this.lisCategorias = [];
    this.lisTodasModalidadesCalificaciones = [];
    this.carInformacionInicial = true;
    forkJoin(
      this.lisServicio.getMasterDetails('ListasCategoriasModalidadesCalificaciones'),
      this.modCaliServicio.listadoModalidadesCalificacionesIdModalidad(this.modalidad.idModalidad)
    ).subscribe(([lisCategorias, todasModalidadesCalificaciones]) => {
        this.lisTodasCategorias = lisCategorias;
        this.lisTodasModalidadesCalificaciones = todasModalidadesCalificaciones;

        // Se selecciona las modalidadeCalificaciones habilitadas
        this.llenarModalidadesCalificaciones();
        this.carInformacionInicial = false;
      }
    );
  }

  inicializarFormularios() {
    this.formulario = this.fb.group({
      reincidencia: [this.modalidad.reincidencia ? this.modalidad.reincidencia : null, [Validators.required, Validators.maxLength(5)]],
      diasMora: [this.modalidad.diaMora ? this.modalidad.diaMora : null, [Validators.required, Validators.maxLength(5)]],
    });

    this.formularioCalificacion = this.fb.group({
      idCategoriaModalidadCalificacion: [this.modalidadCalificacion ? this.modalidadCalificacion.idCategoriaModalidadCalificacion : null, [Validators.required]],
      diaMinimoMora: [this.modalidadCalificacion ? this.modalidadCalificacion.diaMinimoMora : null, [Validators.required, Validators.maxLength(5)]],
      diaMaximoMora: [this.modalidadCalificacion ? this.modalidadCalificacion.diaMaximoMora : null, [Validators.required, Validators.maxLength(5)]],
    });
  }

  onSubmit() {
    this.submitted = true;
    if (this.formulario.valid) {
      this.actualizarModalidad();
    }
  }

  onSubmitModalidadCalificacion() {
    this.submittedCalificacion = true;
    if (this.formularioCalificacion.valid) {
      this.crearModalidadCalificacion();
    }
  }

  // Se filtran las categorias, excluyendo las que ya se encuentran en uso
  filtrarCategorias() {
    this.lisCategorias = [];
    for (let cate of this.lisTodasCategorias) {
      let modaliCalificacion = this.lisModalidadesCalificaciones.find(
        x => x.idCategoriaModalidadCalificacion === cate.idLista);
      if (modaliCalificacion === undefined) {
        this.lisCategorias.push({label: cate.nombre, value: cate.idLista});
      }
    }
  }

  actualizarModalidad() {
    this.guardando = true;
    this.modalidad.diaMora = this.formulario.value.diasMora;
    this.modalidad.reincidencia = this.formulario.value.reincidencia;
    this.modServicio.actualizar(this.modalidad).subscribe(
      res => {
        this.nav.setMesage(2);
        this.guardando = false;
        this.submitted = false;
      },
      error => {
        this.nav.setMesage(3);
        this.guardando = false;
        this.submitted = false;
      }
    );
  }

  crearModalidadCalificacion() {
    this.guardandoCalificacion = true;
    const formValues = this.formularioCalificacion.getRawValue();
    // Validación de que el dia mora mínimo sea inferior al dia mora máximo
    if (formValues.diaMinimoMora >= formValues.diaMaximoMora) {
      this.nav.setMesage(0, {
        severity: 'info', summary: this.nav.buscarMensaje('LBL_INFORMACION'),
        detail: this.nav.buscarMensaje('MODALIDADES.LBL_VALIDACIONDIAMORA')
      });
      this.guardandoCalificacion = false;
    } else {
      if (this.filtrarRangoDiaMora(this.formularioCalificacion.value.diaMinimoMora, this.formularioCalificacion.value.diaMaximoMora)) {
        this.nav.setMesage(0, {
          severity: 'info', summary: this.nav.buscarMensaje('LBL_INFORMACION'),
          detail: this.nav.buscarMensaje('MODALIDADES.LBL_ERRORRANGO')
        });
        this.guardandoCalificacion = false;

      } else {
      // Verificamos si la modalidadCalificacion ya existe
      if (this.modalidadCalificacion !== undefined) {
        this.modalidadCalificacion.diaMaximoMora = this.formularioCalificacion.value.diaMaximoMora;
        this.modalidadCalificacion.diaMinimoMora = this.formularioCalificacion.value.diaMinimoMora;
        this.modCaliServicio.actualizar(this.modalidadCalificacion).subscribe(
          res => {
            this.formularioCalificacion.reset();
            this.modalidadCalificacion = undefined;
            this.nav.setMesage(1);
            this.inicializarListas();
            this.guardandoCalificacion = false;
            this.submittedCalificacion = false;
          },
          error1 => {
            this.nav.setMesage(3);
            this.inicializarListas();
            this.guardandoCalificacion = false;
            this.submittedCalificacion = false;
          }
        );

        } else {
        // Buscamos si el regitro ya existe
        const modCalificacion = this.lisTodasModalidadesCalificaciones.find(
          x => x.idCategoriaModalidadCalificacion === this.formularioCalificacion.value.idCategoriaModalidadCalificacion);
        if (modCalificacion === undefined) {
          // Obtenemos todos los datos de la categoría
          const categoria = this.lisTodasCategorias.find(
            x => x.idLista === this.formularioCalificacion.value.idCategoriaModalidadCalificacion);
          this.modalidadCalificacion = {} as ModalidadCalificacion;
          this.modalidadCalificacion.indicadorHabilitado = true;
          this.modalidadCalificacion.idModalidad = this.modalidad.idModalidad;
          this.modalidadCalificacion.nombreCategoria = categoria.nombre;
          this.modalidadCalificacion.codigoCategoria = categoria.codigo;
          this.modalidadCalificacion.diaMaximoMora = this.formularioCalificacion.value.diaMaximoMora;
          this.modalidadCalificacion.diaMinimoMora = this.formularioCalificacion.value.diaMinimoMora;
          this.modalidadCalificacion.idCategoriaModalidadCalificacion = this.formularioCalificacion.value.idCategoriaModalidadCalificacion;

          this.modCaliServicio.crear(this.modalidadCalificacion).subscribe(
            res => {
              this.formularioCalificacion.reset();
              this.modalidadCalificacion = undefined;
              this.nav.setMesage(1);
              this.guardandoCalificacion = false;
              this.submittedCalificacion = false;
              this.inicializarListas();
            },
            error => {
              this.formularioCalificacion.reset();
              this.modalidadCalificacion = undefined;
              this.nav.setMesage(3);
              this.guardandoCalificacion = false;
              this.submittedCalificacion = false;
            });
        } else {
          modCalificacion.indicadorHabilitado = true;
          modCalificacion.diaMaximoMora = this.formularioCalificacion.value.diaMaximoMora;
          modCalificacion.diaMinimoMora = this.formularioCalificacion.value.diaMinimoMora;
          this.modCaliServicio.actualizar(modCalificacion).subscribe(
            res => {
              this.formularioCalificacion.reset();
              this.modalidadCalificacion = undefined;
              this.nav.setMesage(1);
              this.guardandoCalificacion = false;
              this.submittedCalificacion = false;
              this.inicializarListas();
            },
            error1 => {
              this.formularioCalificacion.reset();
              this.modalidadCalificacion = undefined;
              this.nav.setMesage(3);
              this.guardandoCalificacion = false;
              this.submittedCalificacion = false;

            }
          );
        }
      }
      }
    }
  }

  eliminarModalidadCalificacion( modalidadCalificacion: ModalidadCalificacion) {
    this.confirmationService.confirm({
      message: 'Esta seguro de eliminar este registro?',
      header: this.nav.buscarMensaje('LBL_CONFIRMACION'),
      icon: 'fa fa-question-circle',
      accept: () => {
        this.modalidadCalificacion = modalidadCalificacion
        this.guardandoCalificacion = true;
        this.modalidadCalificacion.indicadorHabilitado = false;
        this.modCaliServicio.actualizar(this.modalidadCalificacion).subscribe(
          res => {
            this.modalidadCalificacion = undefined;
            this.guardandoCalificacion = false;
            this.submittedCalificacion = false;
            this.formularioCalificacion.reset();
            this.inicializarListas();

          },
          error => {
            this.guardando = false;
            this.guardandoCalificacion = false;
            this.submittedCalificacion = false;
            this.modalidadCalificacion = undefined;
            this.formularioCalificacion.reset();
            this.inicializarListas();
          }
        );
      },
      reject: () => {
      }
    });
  }

  // Carga la modalidad calificacion en el formulario para ser editada
  editarModalidadCalificacion( modalidadCalificacion: ModalidadCalificacion) {
    this.modalidadCalificacion = modalidadCalificacion;
    this.inicializarFormularios();
  }

  filtrarRangoDiaMora( diaMin: number, diaMax: number): boolean {
    if (this.lisModalidadesCalificaciones.length === 0) {
      return false;
    }
    let interseccion = true;
    for (let modalidadCalificacion of this.lisModalidadesCalificaciones) {
      if ( diaMin > modalidadCalificacion.diaMaximoMora  || diaMax < modalidadCalificacion.diaMinimoMora) {
        interseccion = false;
      }
    }
    return  interseccion;
  }

  get f() {
    return this.formulario.controls;
  }

  get fCalificacion() {
    return this.formularioCalificacion.controls;
  }

}
